import { RouteConfig } from 'vue-router';

import { Errors } from '@/enums/errors.enum';
import store from '@/store/store';
import { getProcedureDetailsData } from '@/utils/procedure';
import { procedureAttachmentsRoute } from './details/attachments.route';
import { procedureDocumentationRoute } from './details/documentation.route';
import { procedureEditGeneratedRoute } from './details/editGenerated.route';
import { procedureGenerateRoute } from './details/generate.route';
import { procedurePlanRoute } from './details/plan.route';
import { procedureReportFinancialRoute } from './details/reportFinancial.route';
import { procedureReportGroupsRoute } from './details/reportGroups.route';
import { procedureReportListRoute } from './details/reportList.route';
import { procedureReportStatisticsRoute } from './details/reportStatistics.route';
import { procedureViewRoute } from './details/view.route';
import { documentRoute } from './document.route';
import { documentPacksRoute } from './documentPacks.route';
import { procedureEditRoute } from './edit.route';
import { procedurePaymentContainerRoute } from './payments/paymentContainer.route';
import { procedurePaymentListRoute } from './payments/paymentList.route';

export const procedureDetailsRoute: RouteConfig = {
  path: ':procedureId',
  name: 'procedureDetails',
  component: () => import(/* webpackChunkName: "ProcedureDetails" */ '@/views/mainRoute/procedure/Details.vue'),
  children: [
    documentPacksRoute,
    documentRoute,
    procedureAttachmentsRoute,
    procedureDocumentationRoute,
    procedureEditGeneratedRoute,
    procedureEditRoute,
    procedureGenerateRoute,
    procedurePaymentListRoute,
    procedurePaymentContainerRoute,
    procedurePlanRoute,
    procedureReportFinancialRoute,
    procedureReportListRoute,
    procedureReportGroupsRoute,
    procedureReportStatisticsRoute,
    procedureViewRoute
  ],
  redirect: { name: 'procedureView' },
  meta: { breadcrumb: { title: 'Procedura', name: 'procedureView' } },
  beforeEnter: (to, from, next) => {
    getProcedureDetailsData(to)
      .then(() => next())
      .catch(err => store.dispatch('notifyError', { title: Errors.PROCEDURE_CANNOT_GET }));
  }
};
